import { TamediaStyles } from '@ta-interaktiv/microfrontend-template-helpers'
import { FC, ReactElement, useState } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Form } from 'components/Form'
import { TEXT_DE } from './texts_de'
import { TEXT_FR } from './texts_fr'
import { Header } from 'components/Header'
import { UserText } from 'components/UserText'
import Chart from 'components/Charts_Chart'
import { Bars } from 'components/Charts_Bars'
import { StackedBars } from 'components/Charts_StackedBars'
import {
  BFS_FREQUENCY_AGE,
  BFS_FREQUENCY_AGE_Type,
} from './bfs_frequenzy_agegroup'
import Key from 'components/Charts_Key'
import { RiskAssessment } from 'components/RiskAssessment'
const maxKey = 30
const isMobile = window.innerWidth < 712
//

const LANGUAGE: 'de' | 'fr' = 'de'
// ---

//
const median = (arr: number[]) => {
  const mid = Math.floor(arr.length / 2),
    nums = [...arr].sort((a, b) => a - b)
  return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2
}
const roundToNearest = (x: number, v: number) => Math.ceil(x / v) * v
const n = (num: number, precision = 1) =>
  (+num.toFixed(precision)).toLocaleString('de-CH')

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const [userInputs, setUserInputs] = useState<UserInputTypes | undefined>()
  const [maxXBars, setMaxXBars] = useState(10)
  const LANGUAGE: 'de' | 'fr' = (tenant as any).lang

  const TEXT = (tenant as any).lang === 'de' ? TEXT_DE : TEXT_FR
  const AGEGROUPS: { [key: string]: string } = TEXT.agegroups
  const FREQUENCY_KEY = [
    {
      type: 'shape',
      label: TEXT.evaluation.frequency[0],
      color: ['var(--purple-dark-1)'],
    },
    {
      type: 'shape',
      label: TEXT.evaluation.frequency[1],
      color: ['var(--purple-bright-1)'],
    },
    {
      type: 'shape',
      label: TEXT.evaluation.frequency[2],
      color: ['var(--blue-main)'],
    },
    {
      type: 'shape',
      label: TEXT.evaluation.frequency[3],
      color: ['var(--blue-bright-2)'],
    },
    {
      type: 'shape',
      label: TEXT.evaluation.frequency[4],
      color: ['var(--gray-4)'],
    },
  ]

  const [userGenderData, setUserGenderData] = useState<
    FormatedUserDataGenderType | undefined
  >()
  const [userFrequencyData, setUserFrequencyData] = useState<
    FormatedUserDataFrequencyType | undefined
  >()
  const [userRiskData, setUserRiskData] = useState<
    FormatedUserRiskDataType | undefined
  >()
  // const [userDrinkData, setUserDrinkData] = useState<
  //   FormatedUserDataDrinkType | undefined
  // >()
  // const [userHeavyData, setUserHeavyData] = useState<
  //   FormatedUserDataHeavyType | undefined
  // >()

  const handleUserDataChange = (data: DBDataType | undefined) => {
    if (!data) return
    const { gender, frequency, risk } = data
    let overallgendercount = { f: 0, m: 0 }
    console.log({data})
    // GENDER DATA
    if (gender) {
      let f = Object.entries(gender.f).map(([key, value]) => ({
        v: value,
        key: +key.replace('_', '.'),
      }))
      let countOverMax_f = f
        .filter((f) => f.key >= maxKey)
        .reduce((a, b) => a + b.v, 0)
      f = f.filter((f) => f.key < maxKey)
      f.push({ key: maxKey + 1, v: countOverMax_f })
      let m = Object.entries(gender.m).map(([key, value]) => ({
        v: value,
        key: +key.replace('_', '.'),
      }))
      let countOverMax_m = m
        .filter((f) => f.key > maxKey)
        .reduce((a, b) => a + b.v, 0)
      m = m.filter((f) => f.key <= maxKey)
      m.push({ key: maxKey + 1, v: countOverMax_m })

      // Participant Count
      let fSum = f.reduce((a, b) => a + b.v, 0) // Women
      let mSum = m.reduce((a, b) => a + b.v, 0) // Men
      let sum = fSum + mSum // Total
      // Participant Average
      let fAve = f.reduce((a, b) => a + b.key * b.v, 0) / fSum
      let mAve = m.reduce((a, b) => a + b.key * b.v, 0) / mSum
      let ave =
        (m.reduce((a, b) => a + b.key * b.v, 0) +
          f.reduce((a, b) => a + b.key * b.v, 0)) /
        sum

      // Participants Median
      const valueArray = (m: { v: number; key: number }) =>
        [...Array(m.v)].fill(m.key)

      let fMed = median(f.map(valueArray).flat())
      let mMed = median(m.map(valueArray).flat())
      let med = median(f.concat(m).map(valueArray).flat())
      overallgendercount = { f: fSum, m: mSum }
      setUserGenderData({
        f,
        m,
        fSum,
        mSum,
        sum,
        fAve,
        mAve,
        ave,
        fMed,
        mMed,
        med,
      })
      let maxx = roundToNearest(
        Math.max(...m.map((m) => m.v), ...f.map((m) => m.v)),
        10
      )
      setMaxXBars(maxx)
    }
    if (frequency) {
      let { f, m } = frequency
      let fSum = Object.values(f).reduce((a, b) => a + b, 0)
      let mSum = Object.values(m).reduce((a, b) => a + b, 0)
      let sum = fSum + mSum
      let fRel: { [key: string]: number | string } = {}
      Object.entries(f).map(([key, value]) => {
        fRel[key] = (value * 100) / fSum
      })
      fRel.gender = 'f'
      let mRel: { [key: string]: number | string } = {}
      Object.entries(m).map(([key, value]) => {
        mRel[key] = (value * 100) / mSum
      })
      mRel.gender = 'm'

      setUserFrequencyData({ fSum, mSum, sum, f, m, fRel, mRel })
    }

    if (risk) {
      let { f, m } = risk
      let fSum = overallgendercount.f
      let mSum = overallgendercount.m

      let sum = fSum + mSum
      let t = {
        none: m.none + f.none,
        low: m.low + f.low,
        middle: m.middle + f.middle,
        high: m.high + f.high,
      }

      setUserRiskData({ fSum, mSum, sum, f, m, t })
    }
  }

  console.groupCollapsed('MainComponent')
  console.log({ userGenderData, userRiskData })
  console.groupEnd()
  return (
    <AppContainer className={globalClasses.join(' ')}>
      <Header tenant={tenant} colorMode={colorMode} />
      <Form
        getUserInputs={setUserInputs}
        getDBData={handleUserDataChange}
        TEXT={TEXT.calculator}
      />

      {userInputs && userInputs.gender !== '_' && (
        <TextWidth>
          <h4>{TEXT.evaluation.title}</h4>
          {userRiskData && userGenderData && (
            <>
              <UserText
                userInputs={userInputs}
                userGenderData={userGenderData}
                LANGUAGE={LANGUAGE}
              />
              <Chart
                title={TEXT.evaluation.chart1.title}
                sub={
                  TEXT.evaluation.chart1.sub[0] +
                  n(userGenderData.sum) +
                  TEXT.evaluation.chart1.sub[1]
                }
              >
                <ChartWrapper className='aa'>
                  <GenderTitle className='m'>
                    {TEXT.evaluation.chart1.gender[0]}{' '}
                    <GenderSub className='m'>
                      ({n(userGenderData.mSum)})
                    </GenderSub>
                  </GenderTitle>

                  <GenderTitle className='f'>
                    {TEXT.evaluation.chart1.gender[1]}{' '}
                    <GenderSub className='f'>
                      ({n(userGenderData.fSum)})
                    </GenderSub>
                  </GenderTitle>
                  <GenderVerticalKey>
                    <div>{TEXT.evaluation.chart1.key[0]}</div>
                    <br />
                    <img
                      src={require('images/icons_arrow_up.png')}
                      alt='arrow up'
                    />
                  </GenderVerticalKey>
                  <Bars
                    maxKey={maxKey}
                    marked={{
                      data: userInputs,
                      label: TEXT.evaluation.userMarker,
                    }}
                    className='Bars'
                    data={[
                      userGenderData.m
                        .filter((f) => f.v !== 0)
                        .sort((a, b) => a.key - b.key),
                      userGenderData.f
                        .filter((f) => f.v !== 0)
                        .sort((a, b) => a.key - b.key),
                    ]}
                    xDomain={[0, maxXBars]}
                    height={isMobile ? 350 : 500}
                  />
                  <KeyWrapper>
                    <div className='left'>
                      <img
                        src={require('images/icons_arrow_left.png')}
                        alt='arrow left'
                      />
                      {TEXT.evaluation.chart1.key[1]}{' '}
                    </div>

                    <div className='middle'></div>

                    <div className='right'>
                      {TEXT.evaluation.chart1.key[2]}{' '}
                      <img
                        src={require('images/icons_arrow_right.png')}
                        alt='arrow right'
                      />
                    </div>
                  </KeyWrapper>
                </ChartWrapper>
              </Chart>
              <div className='spacer' style={{ marginBottom: '60px' }} />
              {userGenderData && (
                <Chart
                  title={
                    TEXT.evaluation.chart2.title +
                    ' ' +
                    TEXT.evaluation.chart2.sub[0] +
                    n(userGenderData.sum) +
                    TEXT.evaluation.chart2.sub[1]
                  }
                >
                  <ChartWrapper>
                    {userInputs.gender !== '_' && (
                      <>
                        {userInputs && userFrequencyData && (
                          <>
                            <StackedBars
                              gender={'m'}
                              data={[
                                {
                                  ...userFrequencyData.mRel,
                                  agegroup: userInputs.age,
                                } as BFS_FREQUENCY_AGE_Type,
                              ]}
                              rowLabel={
                                (e: { [key: string]: any }) =>
                                  e.gender === 'f'
                                    ? TEXT.evaluation.chart1.gender[1] //+
                                    : TEXT.evaluation.chart1.gender[0] //+
                              }
                              className='readerstacked'
                              height={42}
                              marked={{
                                data: userInputs,
                                label: TEXT.evaluation.userMarker,
                                show: userInputs.gender === 'm',
                              }}
                              groupLabels={TEXT.evaluation.frequency}
                            />
                            <StackedBars
                              gender={'f'}
                              data={[
                                {
                                  ...userFrequencyData.fRel,
                                  agegroup: userInputs.age,
                                } as BFS_FREQUENCY_AGE_Type,
                              ]}
                              rowLabel={
                                (e: { [key: string]: any }) =>
                                  e.gender === 'f'
                                    ? TEXT.evaluation.chart1.gender[1] //+
                                    : TEXT.evaluation.chart1.gender[0] //+
                              }
                              className='readerstacked'
                              height={42}
                              marked={{
                                data: userInputs,
                                label: TEXT.evaluation.userMarker,
                                show: userInputs.gender === 'f',
                              }}
                              groupLabels={TEXT.evaluation.frequency}
                            />
                          </>
                        )}
                        <Key entries={FREQUENCY_KEY} />
                      </>
                    )}
                  </ChartWrapper>
                </Chart>
              )}
              {userGenderData && userInputs.gender !== '_' && (
                <Chart
                  title={TEXT.evaluation.chart3.title}
                  sub={TEXT.evaluation.chart3.sub}
                >
                  <ChartWrapper>
                    {userInputs && userInputs.gender !== '_' && (
                      <>
                        <GenderTitle className='left '>
                          {TEXT.evaluation.chart3.gender[0]}
                        </GenderTitle>
                        <StackedBars
                          gender={'m'}
                          data={BFS_FREQUENCY_AGE.filter(
                            (f) => f.gender === 'm'
                          )}
                          className='malestacked'
                          rowLabel={(e: { [key: string]: any }) =>
                            AGEGROUPS[e.agegroup]
                          }
                          marked={{
                            data: userInputs,
                            label: TEXT.evaluation.userMarker,
                            show: userInputs.gender === 'm',
                          }}
                          height={280}
                          groupLabels={TEXT.evaluation.frequency}
                        />{' '}
                        <Key entries={FREQUENCY_KEY} />
                      </>
                    )}

                    <GenderTitle className='left'>
                      {TEXT.evaluation.chart3.gender[1]}
                    </GenderTitle>
                    <StackedBars
                      gender={'f'}
                      data={BFS_FREQUENCY_AGE.filter((f) => f.gender === 'f')}
                      rowLabel={(e: { [key: string]: any }) =>
                        AGEGROUPS[e.agegroup]
                      }
                      marked={{
                        data: userInputs,
                        label: TEXT.evaluation.userMarker,
                        show: userInputs.gender === 'f',
                      }}
                      className='malestacked'
                      height={280}
                      groupLabels={TEXT.evaluation.frequency}
                    />

                    <Key entries={FREQUENCY_KEY} />
                  </ChartWrapper>
                </Chart>
              )}
              {userRiskData && (
                <>
                  <RiskAssessment
                  genderData={userGenderData}
                    user={userInputs}
                    data={userRiskData}
                    labels={TEXT.risk}
                    lang={LANGUAGE}
                  />
                </>
              )}
              <Source>
                {TEXT.evaluation.source[0]} {TEXT.evaluation.source[1]}
              </Source>
            </>
          )}
        </TextWidth>
      )}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  background-color: var(--site-background);
  a {
    color: var(--text-color) !important;
  }
  text {
    fill: var(--text-color);
  }
  h4 {
    /* max-width: ${isMobile ? '100%' : '70%'}; */

    margin-left: auto;
    margin-right: auto;
    font-size: 26px;
    line-height: 1.4em;
  }
`
const ChartWrapper = styled.div`
  flex: 0 0 100%;
  @media only screen and (max-width: 711px) {
    flex: 0 0 calc(100%);
    max-width: calc(100%);
  }
`
const GenderVerticalKey = styled.div`
  width: 100%;
  display: inline-block;
  text-align: center;
  font-size: 12px;
  line-height: 1.5em;
  div {
    display: inline-block;

    width: 30%;
    @media only screen and (max-width: 711px) {
      width: 100%;
    }
  }
  img {
    margin-top: 10px;
    clear: both;
    width: 16px;
  }
`
const GenderTitle = styled.div`
  display: inline-block;
  font-size: 26px;
  width: 50%;
  text-align: center;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 1em;

  margin-bottom: 15px;
  &.left {
    text-align: left;
    width: 100%;
  }
`
const GenderSub = styled.div`
  display: inline-block;
  font-size: 15px;
  text-align: center;
  font-weight: 400;
  line-height: 1em;
  letter-spacing: 0.5px;
  color: var(--brandblue-bright-3);
  width: 100%;
  &.left {
    width: 100%;
  }
  b {
    font-weight: 700;
    font-size: 16px;
  }
  @media only screen and (max-width: 711px) {
    font-size: 12px;
    b {
      font-size: 15px;
    }
  }
`
const Source = styled.div`
  font-size: 12px;
  line-height: 1.4em;
  font-family: var(--font-sans-serif);
  margin-top: 30px;
  margin-bottom: 60px;
  a {
    color: var(--text-color) !important;
  }
`
const KeyWrapper = styled.div`
  display: flex;
  width: 100%;
  font-size: 12px;
  padding-top: 0px;
  line-height: 1.5em;
  img {
    max-width: 15px;
  }

  div {
    display: flex;
    align-items: baseline;
    flex: 0 0 37%;
    &.left {
      padding-right: 15%;
      img {
        margin-right: 5px;
      }
    }
    &.middle {
      flex: 0 0 26%;
      text-align: center;
      flex-direction: column;
      align-items: center;
      margin-top: 0;
      padding-left: 10px;
      padding-right: 10px;
    }
    &.right {
      padding-left: 15%;

      img {
        margin-left: 5px;
      }
      text-align: right;
    }
  }
  @media only screen and (max-width: 711px) {
    div {
      flex: 0 0 37%;
      &.left {
        padding-right: 0;
      }
      &.middle {
        padding: 0;
      }
      &.right {
        padding: 0;
      }
    }
  }
`
export default MainComponent
